// src/state/menu/types.ts
var SET_MASTER_MENU_ON_STATE = "SET_MASTER_MENU_ON_STATE";
var SET_LOCATION_MENU_ON_STATE = "SET_LOCATION_MENU_ON_STATE";
var SET_SELECTED_MENU_MODE = "SET_SELECTED_MENU_MODE";
var SET_MASTER_MENU_ON_STATE_WS = "SET_MASTER_MENU_ON_STATE_WS";
var SET_LOCATION_MENU_ON_STATE_WS = "SET_LOCATION_MENU_ON_STATE_WS";
var SET_SELECTED_MENU_MODE_WS = "SET_SELECTED_MENU_MODE_WS";
var SET_CHANGE_DATA = "SET_CHANGE_DATA";
var SET_CHANGE_MASS_UPDATE_DATA = "SET_CHANGE_MASS_UPDATE_DATA";
var SET_CHANGE_FRESH_SHEET_DATA = "SET_CHANGE_FRESH_SHEET_DATA";
var RESET_CHANGE_DATA = "RESET_CHANGE_DATA";
var RESET_CHANGE_MASS_UPDATE_DATA = "RESET_CHANGE_MASS_UPDATE_DATA";
var RESET_CHANGE_FRESH_SHEET_DATA = "RESET_CHANGE_FRESH_SHEET_DATA";
var SET_CHANGE_DATA_VALUES = "SET_CHANGE_DATA_VALUES";
var SET_CHANGE_MASS_UPDATE_DATA_VALUES = "SET_CHANGE_MASS_UPDATE_DATA_VALUES";
var SET_CHANGE_FRESH_SHEET_DATA_VALUES = "SET_CHANGE_FRESH_SHEET_DATA_VALUES";
var SET_CHANGE_DATA_MODIFIER_GROUPS_VALUES = "SET_CHANGE_DATA_MODIFIER_GROUPS_VALUES";
var SET_CHANGE_DATA_MODIFIER_ITEMS_VALUES = "SET_CHANGE_DATA_MODIFIER_ITEMS_VALUES";
var SET_CHANGE_DATA_MENU_TYPE_VERSIONS_VALUES = "SET_CHANGE_DATA_MENU_TYPE_VERSIONS_VALUES";
var SET_DIFFERENCES = "SET_DIFFERENCES";
var SET_BREADCRUMB_LOCATION = "SET_BREADCRUMB_LOCATION";
var SET_BREADCRUMB = "SET_BREADCRUMB";
var SET_REMOTE_LOCATION_MENU_ON_STATE = "SET_REMOTE_LOCATION_MENU_ON_STATE";
var SET_REMOTE_LOCATION_MENU_ON_STATE_WS = "SET_REMOTE_LOCATION_MENU_ON_STATE_WS";
var SET_ITEM_PRICE_LIST = "SET_ITEM_PRICE_LIST";
var SET_ERRORS = "SET_ERRORS";
var SET_MASS_UPDATE_ERRORS = "SET_MASS_UPDATE_ERRORS";
var RESET_MENU_CHANGES = "RESET_MENU_CHANGES";
var RESET_MASS_UPDATE_MENU_CHANGES = "RESET_MASS_UPDATE_MENU_CHANGES";
var SET_MENU_VERSIONS = "SET_MENU_VERSIONS";
var SET_MENU_VERSIONS_WS = "SET_MENU_VERSIONS_WS";
var SET_SELECTED_LOCATIONS = "SET_SELECTED_LOCATIONS";
var SET_MASS_UPDATE_SELECTED_LOCATIONS = "SET_MASS_UPDATE_SELECTED_LOCATIONS";
var SET_LAST_PREVIEW_ARRANGEMENT = "SET_LAST_PREVIEW_ARRANGEMENT";
var SET_PREVIEW_ELEMENTS = "SET_PREVIEW_ELEMENTS";
var UPDATE_PREVIEW_ELEMENTS = "UPDATE_PREVIEW_ELEMENTS";
var SET_MENU_PREVIEW_ACTION = "SET_MENU_PREVIEW_ACTION";
var SET_LOCAL_ITEM_86 = "SET_LOCAL_ITEM_86";
var SET_LOCAL_MODIFIER_ITEM_86 = "SET_LOCAL_MODIFIER_ITEM_86";
var SET_LOCAL_INGREDIENT_86 = "SET_LOCAL_INGREDIENT_86";
var RESET_LOCAL_ITEM_STOCK = "RESET_LOCAL_ITEM_STOCK";
var UPDATE_LOCAL_ITEM_STOCK = "UPDATE_LOCAL_ITEM_STOCK";
var UPDATE_LOCAL_ITEM_SHOW_STOCK_ON_ITEM_CARD = "UPDATE_LOCAL_ITEM_SHOW_STOCK_ON_ITEM_CARD";
var UPDATE_INVENTORY_WS = "UPDATE_INVENTORY_WS";
var UPDATE_MODIFIER_ITEM_INVENTORY_WS = "UPDATE_MODIFIER_ITEM_INVENTORY_WS";
var UPDATE_INGREDIENT_INVENTORY_WS = "UPDATE_INGREDIENT_INVENTORY_WS";
var UPDATE_INVENTORY = "UPDATE_INVENTORY";
var SET_DIFF_OBJECT = "SET_DIFF_OBJECT";
var UPDATE_CHANGE_DATA_VALUES = "UPDATE_CHANGE_DATA_VALUES";
var UPDATE_CHANGE_MASS_UPDATE_DATA_VALUES = "UPDATE_CHANGE_MASS_UPDATE_DATA_VALUES";
var UPDATE_CHANGE_FRESH_SHEET_DATA_VALUES = "UPDATE_CHANGE_FRESH_SHEET_DATA_VALUES";
var UPDATE_MENU = "UPDATE_MENU";
var POST_REQUEST_MENU = "POST_REQUEST_MENU";
var BUCKET_TEXT_DICTIONARY = {
  categories: "menuScreen.common.bucket.categories.plural",
  menuTypes: "menuScreen.common.bucket.menuTypes.plural",
  items: "menuScreen.common.bucket.items.plural",
  modifierItems: "menuScreen.common.bucket.modifierItems.plural",
  modifierGroups: "menuScreen.common.bucket.modifierGroups.plural",
  subcategories: "menuScreen.common.bucket.subcategories.plural",
  discounts: "menuScreen.common.bucket.discounts.plural",
  combos: "menuScreen.common.bucket.combos.plural",
  hotButtons: "commonTexts.na",
  specials: "menuScreen.common.bucket.specials.plural",
  ingredients: "menuScreen.common.bucket.ingredients.plural",
  itemGroups: "menuScreen.common.bucket.itemGroups.plural",
  reportingGroups: "menuScreen.common.bucket.reportingGroups.plural"
};
var BreadCrumbScreens = /* @__PURE__ */ ((BreadCrumbScreens2) => {
  BreadCrumbScreens2["MENU_TYPES_DETAILS"] = "MENU_TYPES_DETAILS";
  BreadCrumbScreens2["CATEGORIES_DETAILS"] = "CATEGORIES_DETAILS";
  BreadCrumbScreens2["SUBCATEGORIES_DETAILS"] = "SUBCATEGORIES_DETAILS";
  BreadCrumbScreens2["ITEMS_DETAILS"] = "ITEMS_DETAILS";
  BreadCrumbScreens2["MODIFIER_ITEMS_DETAILS"] = "MODIFIER_ITEMS_DETAILS";
  BreadCrumbScreens2["MODIFIER_GROUPS_DETAILS"] = "MODIFIER_GROUPS_DETAILS";
  BreadCrumbScreens2["INGREDIENTS_DETAILS"] = "INGREDIENTS_DETAILS";
  BreadCrumbScreens2["COMBOS_DETAILS"] = "COMBOS_DETAILS";
  BreadCrumbScreens2["SPECIALS_DETAILS"] = "SPECIALS_DETAILS";
  BreadCrumbScreens2["DISCOUNTS_DETAILS"] = "DISCOUNTS_DETAILS";
  BreadCrumbScreens2["ITEM_GROUPS_DETAILS"] = "ITEM_GROUPS_DETAILS";
  BreadCrumbScreens2["REPORTING_GROUPS_DETAILS"] = "REPORTING_GROUPS_DETAILS";
  return BreadCrumbScreens2;
})(BreadCrumbScreens || {});
var BreadCrumbAction = /* @__PURE__ */ ((BreadCrumbAction2) => {
  BreadCrumbAction2["NAV_MAIN"] = "nav-main";
  BreadCrumbAction2["NAV"] = "nav";
  BreadCrumbAction2["EDIT"] = "edit";
  BreadCrumbAction2["ADD"] = "add";
  BreadCrumbAction2["REPLACE"] = "replace";
  BreadCrumbAction2["MASS_UPDATE"] = "mass-update";
  BreadCrumbAction2["NAV_OTHER"] = "nav-other";
  return BreadCrumbAction2;
})(BreadCrumbAction || {});
var MenuTypes = /* @__PURE__ */ ((MenuTypes2) => {
  MenuTypes2["MASTER_MENU"] = "masterMenu";
  MenuTypes2["LOCATION_MENU"] = "locationMenu";
  MenuTypes2["REMOTE_LOCATION_MENU"] = "remoteLocationMenu";
  return MenuTypes2;
})(MenuTypes || {});
var FormMode = /* @__PURE__ */ ((FormMode2) => {
  FormMode2["CREATE"] = "create";
  FormMode2["UPDATE"] = "update";
  FormMode2["MASS_UPDATE"] = "mass_update";
  return FormMode2;
})(FormMode || {});
var MassUpdateValues = /* @__PURE__ */ ((MassUpdateValues2) => {
  MassUpdateValues2["NO_CHANGES"] = "\xABNo Changes\xBB";
  return MassUpdateValues2;
})(MassUpdateValues || {});
var SectionId = /* @__PURE__ */ ((SectionId2) => {
  SectionId2["ALL"] = "all";
  SectionId2["HIDDEN"] = "hidden";
  SectionId2["MENU_TYPES"] = "menuTypes";
  SectionId2["BASIC"] = "basic";
  SectionId2["REGISTER"] = "register";
  SectionId2["MORE_INFO"] = "moreInfo";
  SectionId2["INGREDIENTS"] = "ingredients";
  SectionId2["AVAILABILITY"] = "availability";
  SectionId2["ASSOCIATION"] = "association";
  SectionId2["PRICING"] = "pricing";
  SectionId2["TAXES"] = "taxes";
  SectionId2["MODIFIERS"] = "modifiers";
  SectionId2["MOD_ITEMS"] = "modItems";
  SectionId2["MODIFIER_GROUPS"] = "modifierGroups";
  SectionId2["SUGGESTIVE_ORDERING"] = "suggestiveOrdering";
  SectionId2["LINKED_MOD_ITEMS"] = "linkedModItems";
  SectionId2["ITEMS_AND_MOD_ITEMS"] = "itemsAndModItems";
  SectionId2["MOD_GROUPS_AND_ITEMS"] = "modGroupsAndItems";
  SectionId2["NESTED_MODS"] = "nestedMods";
  SectionId2["INVENTORY"] = "inventory";
  SectionId2["SPECIALS"] = "specials";
  SectionId2["DISCOUNT_SCHEME"] = "discountScheme";
  SectionId2["SPECIAL_SCHEME"] = "specialScheme";
  SectionId2["ITEM_GROUPS"] = "itemGroups";
  SectionId2["PREP_STATIONS"] = "prepStations";
  SectionId2["GUEST_CHECK_DISPLAY"] = "guestCheckDisplay";
  SectionId2["CUSTOM_ID"] = "customId";
  SectionId2["REPORTING_GROUPS"] = "reportingGroups";
  return SectionId2;
})(SectionId || {});
var CreateBucketErrorType = /* @__PURE__ */ ((CreateBucketErrorType2) => {
  CreateBucketErrorType2["OUTDATED_MENU"] = "OUTDATED_MENU";
  CreateBucketErrorType2["OUTDATED_CUSTOMER"] = "OUTDATED_CUSTOMER";
  CreateBucketErrorType2["OUTDATED_SETTINGS"] = "OUTDATED_SETTINGS";
  CreateBucketErrorType2["OUTDATED_MENU_AND_SETTINGS"] = "OUTDATED_MENU_AND_SETTINGS";
  CreateBucketErrorType2["OUTDATED_REPORTS"] = "OUTDATED_REPORTS";
  return CreateBucketErrorType2;
})(CreateBucketErrorType || {});
var SubSections = /* @__PURE__ */ ((SubSections2) => {
  SubSections2["ALL"] = "all";
  SubSections2["PRICING_VERSION"] = "pricingVersion";
  SubSections2["MODIFIER_ITEM"] = "modifierItem";
  SubSections2["ITEMS"] = "items";
  return SubSections2;
})(SubSections || {});
var HomeElementTypes = /* @__PURE__ */ ((HomeElementTypes2) => {
  HomeElementTypes2["GIFT_CARD"] = "gift-card";
  HomeElementTypes2["CASH_DRAWER"] = "cash-drawer";
  HomeElementTypes2["ID_SCAN"] = "id-scan";
  HomeElementTypes2["CUSTOMERS"] = "customers";
  HomeElementTypes2["OPEN_ITEM"] = "open-item";
  HomeElementTypes2["ITEM"] = "item";
  HomeElementTypes2["COMBO"] = "combo";
  HomeElementTypes2["MENU_TYPE"] = "menuType";
  HomeElementTypes2["FIRE"] = "fire";
  HomeElementTypes2["MODIFIER_ITEM"] = "modifier-item";
  HomeElementTypes2["NEW_COURSE"] = "new-course";
  HomeElementTypes2["CATEGORY"] = "category";
  HomeElementTypes2["SUBCATEGORY"] = "subcategory";
  HomeElementTypes2["PRINT_CHECKS"] = "print-checks";
  return HomeElementTypes2;
})(HomeElementTypes || {});
var ENewHomeElement = /* @__PURE__ */ ((ENewHomeElement2) => {
  ENewHomeElement2["ID_PREFIX"] = "new-home-element-";
  return ENewHomeElement2;
})(ENewHomeElement || {});
var MENU_PREVIEW_ACTIONS = /* @__PURE__ */ ((MENU_PREVIEW_ACTIONS2) => {
  MENU_PREVIEW_ACTIONS2["ADD"] = "add";
  MENU_PREVIEW_ACTIONS2["CUSTOMIZE"] = "customize";
  return MENU_PREVIEW_ACTIONS2;
})(MENU_PREVIEW_ACTIONS || {});
var Entity86 = /* @__PURE__ */ ((Entity862) => {
  Entity862["ITEM"] = "item";
  Entity862["MODIFIER_ITEM"] = "modifierItem";
  Entity862["INGREDIENT"] = "ingredient";
  return Entity862;
})(Entity86 || {});

export { BUCKET_TEXT_DICTIONARY, BreadCrumbAction, BreadCrumbScreens, CreateBucketErrorType, ENewHomeElement, Entity86, FormMode, HomeElementTypes, MENU_PREVIEW_ACTIONS, MassUpdateValues, MenuTypes, POST_REQUEST_MENU, RESET_CHANGE_DATA, RESET_CHANGE_FRESH_SHEET_DATA, RESET_CHANGE_MASS_UPDATE_DATA, RESET_LOCAL_ITEM_STOCK, RESET_MASS_UPDATE_MENU_CHANGES, RESET_MENU_CHANGES, SET_BREADCRUMB, SET_BREADCRUMB_LOCATION, SET_CHANGE_DATA, SET_CHANGE_DATA_MENU_TYPE_VERSIONS_VALUES, SET_CHANGE_DATA_MODIFIER_GROUPS_VALUES, SET_CHANGE_DATA_MODIFIER_ITEMS_VALUES, SET_CHANGE_DATA_VALUES, SET_CHANGE_FRESH_SHEET_DATA, SET_CHANGE_FRESH_SHEET_DATA_VALUES, SET_CHANGE_MASS_UPDATE_DATA, SET_CHANGE_MASS_UPDATE_DATA_VALUES, SET_DIFFERENCES, SET_DIFF_OBJECT, SET_ERRORS, SET_ITEM_PRICE_LIST, SET_LAST_PREVIEW_ARRANGEMENT, SET_LOCAL_INGREDIENT_86, SET_LOCAL_ITEM_86, SET_LOCAL_MODIFIER_ITEM_86, SET_LOCATION_MENU_ON_STATE, SET_LOCATION_MENU_ON_STATE_WS, SET_MASS_UPDATE_ERRORS, SET_MASS_UPDATE_SELECTED_LOCATIONS, SET_MASTER_MENU_ON_STATE, SET_MASTER_MENU_ON_STATE_WS, SET_MENU_PREVIEW_ACTION, SET_MENU_VERSIONS, SET_MENU_VERSIONS_WS, SET_PREVIEW_ELEMENTS, SET_REMOTE_LOCATION_MENU_ON_STATE, SET_REMOTE_LOCATION_MENU_ON_STATE_WS, SET_SELECTED_LOCATIONS, SET_SELECTED_MENU_MODE, SET_SELECTED_MENU_MODE_WS, SectionId, SubSections, UPDATE_CHANGE_DATA_VALUES, UPDATE_CHANGE_FRESH_SHEET_DATA_VALUES, UPDATE_CHANGE_MASS_UPDATE_DATA_VALUES, UPDATE_INGREDIENT_INVENTORY_WS, UPDATE_INVENTORY, UPDATE_INVENTORY_WS, UPDATE_LOCAL_ITEM_SHOW_STOCK_ON_ITEM_CARD, UPDATE_LOCAL_ITEM_STOCK, UPDATE_MENU, UPDATE_MODIFIER_ITEM_INVENTORY_WS, UPDATE_PREVIEW_ELEMENTS };
